var render, staticRenderFns
import script from "./TournamentUser.vue?vue&type=script&lang=js&"
export * from "./TournamentUser.vue?vue&type=script&lang=js&"
import style0 from "./TournamentUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ea654c')) {
      api.createRecord('b0ea654c', component.options)
    } else {
      api.reload('b0ea654c', component.options)
    }
    
  }
}
component.options.__file = "src/components/Tournament/TournamentUser.vue"
export default component.exports